import axios from "axios";

export const getToken = async (): Promise<string> => {
  const url =
    "https://us-central1-beauty-by-me-4fc72.cloudfunctions.net/getShopifyToken";
  const response = await axios.get(url);
  return response.data.token;
};
